const INTERNAL_PATH_ORIGIN = 'https://attune.local';

export function normalizeSafeInternalPath(
  value: unknown,
  fallback: string | null = null
): string | null {
  if (typeof value !== 'string' || !value.startsWith('/')) {
    return fallback;
  }

  try {
    const url = new URL(value, INTERNAL_PATH_ORIGIN);
    if (
      url.origin !== INTERNAL_PATH_ORIGIN ||
      url.pathname === '/api' ||
      url.pathname.startsWith('/api/')
    ) {
      return fallback;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}
